/**
 * Returns a new array, containing each of the element in the items array provided,
 *    with the result of the callback function between each.
 *
 * Example: betweenEach([ 1, 2, 3 ], () => 'and') => [ 1, 'and', 2, 'and', 3 ]
 */
export function betweenEach<T>(items: T[], callback: (previousIndex: number) => T) {
   let result: T[] = [];
   let lastIndex = items.length - 1;
   for (let index = 0; index < items.length; index++) {
      const item = items[index];
      result.push(item);
      if (index !== lastIndex) {
         result.push(callback(index));
      }
   }
   return result;
}
